import apiSportEventsComments from '@/api/sports-events-comments'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getSportEventsCommentsStart: '[sport events] Get sport events comments start',
  getSportEventsCommentsSuccess:
    '[sport events] Get sport events comments success',
  getSportEventsCommentsFailure:
    '[sport events] Get sport events comments failure'
}

export const actionTypes = {
  getSportEventsComments: '[sport events] Get sport events comments'
}

const mutations = {
  [mutationTypes.getSportEventsCommentsStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getSportEventsCommentsSuccess](state, payload) {
    state.data = payload.data
    state.total = payload.total
    state.isLoading = false
  },

  [mutationTypes.getSportEventsCommentsFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getSportEventsComments](context, {params}) {
    context.commit(mutationTypes.getSportEventsCommentsStart)
    return new Promise(resolve => {
      apiSportEventsComments
        .getSportEventsComments(params)
        .then(response => {
          context.commit(
            mutationTypes.getSportEventsCommentsSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(error => {
          context.commit(mutationTypes.getSportEventsCommentsFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
